module.exports = __webpack_public_path__ + "media/images/invoice/cokobanka-a07c8a6bf5d5a041aba36cb79abe7c29.jpg";